var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow"},[_c('v-icon',{attrs:{"color":"#47cf73"}},[_vm._v("mdi-arrow-right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }